export default {
  itemsPerPage: [
    {
      value: 5
    },
    {
      value: 6
    },
    {
      value: 10
    }
  ]
}



// WEBPACK FOOTER //
// ./src/vuestic-theme/vuestic-components/vuestic-datatable/data/items-per-page-definition.js